import { Container, Loader } from "@mantine/core";

function LoadingComponent() {
  return (
    <>
      <Container
        fluid
        style={{
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader my={20} />
      </Container>
    </>
  );
}

export default LoadingComponent;
